import type {RecordEditationServiceFactory} from './record-edtitation-service.factory';
import type WalkerService from '../commons/services/walker.service';
import type RecordEditationService from './record-editation.service';
import {getRecordPath} from 'shared/utils/data-service-utils';
import type {RecordEditation} from 'typings/portaro.be.types';
import KpValueEditorForceSettingsWrapper
    from '../commons/value-editors/kp-value-editor-force-settings/KpValueEditorForceSettingsWrapper.svelte';

export class PagedRecordEditationController {
    public static controllerName = 'PagedRecordEditationController';

    public kpValueEditorForceSettingsWrapper = KpValueEditorForceSettingsWrapper;
    public editationService: RecordEditationService;
    /*@ngInject*/
    constructor(private recordEditationServiceFactory: RecordEditationServiceFactory,
                private walker: WalkerService) {
    }

    public init(): void {
        this.editationService = this.recordEditationServiceFactory.createService(window.model.editationObject);
    }

    private async successExit() {
        const editationObject: RecordEditation = this.editationService.editation()
        await this.walker.newPage(getRecordPath(editationObject.recordId));
    }

    private nonSuccessExit() {
        window.history.back();
    }

    public async publishDraftAndClose(): Promise<void> {
        await this.editationService.publish();
        await this.successExit();
    }

    public async deleteDraftAndClose(): Promise<void>{
        await this.editationService.remove();
        this.nonSuccessExit();
    }

    public async saveAndClose(): Promise<void> {
        await this.editationService.save();
        await this.successExit();
    }

    public async saveAndContinue(): Promise<void> {
        await this.editationService.save();
    }

    public async discardAndClose(): Promise<void> {
        await this.successExit();
    }
}